import {
  Component,
  ElementRef,
  ViewChild,
  AfterViewInit,
  Input,
  forwardRef
} from '@angular/core'

import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR
} from '@angular/forms'

export const DATE_PICKER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DatePickerComponent),
  multi: true,
}

@Component({
  selector: 'date-picker',
  templateUrl: './date-picker.component.html',
  providers: [
    DATE_PICKER_VALUE_ACCESSOR
  ]
})
export class DatePickerComponent implements AfterViewInit, ControlValueAccessor  {
  @Input() format = 'MMM D, YYYY'
  @Input() min: Date
  @Input() max: Date
  @Input() opens: string = 'right'
  @Input() disabled: boolean = false
  @Input() editable: boolean = false
  value: Date

  @ViewChild('elementRef') elementRef: ElementRef

  $element: any
  onChangeCallback: any

  ngAfterViewInit() {
    this.$element = $(this.elementRef.nativeElement)

    const options = {
      singleDatePicker: true,
      buttonClasses: 'ui button fluid',
      autoUpdateInput: false,
      template: '',
      locale: {
        format: this.format
      },
      minDate: this.min,
      maxDate: this.max,
      opens: this.opens,
    }

    if (this.value) {
      options['startDate'] = this.value
    }

    options.template = `
      <div class="daterangepicker dropdown-menu ui compact segment grid" style="display: none;">
        <div class="column calendar left">
          <div class="calendar-table"></div>
        </div>
      </div>`

    this.$element.daterangepicker(options)
    if (this.value) {
      this.setStringValue()
    }

    this.addEventListeners()
  }

  addEventListeners() {
    this.$element.on('show.daterangepicker', (ev, picker) => {
      picker.elementChanged()
    })

    this.$element.on('apply.daterangepicker', (ev, picker) => {
      this.updateDate(picker)
    })
  }

  onBlur() {
    const picker = this.$element.data('daterangepicker')
    if (new Date(this.value).getTime() !== new Date(picker.startDate.toDate()).getTime()) {
      this.updateDate(picker)
    }
  }

  setStringValue() {
    const picker = this.$element.data('daterangepicker')
    const format = picker.locale.format
    if (picker && picker.startDate) {
       const stringVal = picker.startDate.format(format)
       this.$element.val(stringVal)
    }
  }

  writeValue(value: Date) {
    this.value = value
    if (!value) {
      if (this.$element) {
        this.$element.val('');
      }
      return
    }

    if (this.value && this.$element) {
      const picker = this.$element.data('daterangepicker')
      picker.setStartDate(this.value)

      this.setStringValue()
    }
  }

  setDisabledState(disabled) {
    this.disabled = disabled
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn
  }

  registerOnTouched(fn: any) { }

  private updateDate(picker) {
    this.setStringValue()
    this.value = picker.startDate.toDate()
    if (typeof this.onChangeCallback === 'function') {
      this.onChangeCallback(this.value)
    }
  }
}
